import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { getUsers } from '../user/get-users'

export const getContactInParis = () => getUsers({ filter: { roles: [RoleEnum.ADMIN] } })
